import range from 'lodash/range';
import map from 'lodash/map';
import { compare } from 'utils/dateTools';
import { EMPLOYEE_TAB } from 'constants/DataTypes';
import {
  REQUEST_APPRAISAL,
  REQUEST_APPRAISAL_SUCCESS,
  REQUEST_APPRAISAL_FAILURE,
  REQUEST_APPRAISAL_BY_ID,
  REQUEST_APPRAISAL_BY_ID_SUCCESS,
  REQUEST_APPRAISAL_BY_ID_FAILURE,
  SET_FINAL_ANSWERS,
  SET_MANAGER_ANSWERS,
  SET_EMPLOYEE_ANSWERS,
  RESET_APPRAISAL_LOADING,
  SAVING_APPRAISAL,
  SAVING_APPRAISAL_SUCCESS,
  SAVING_APPRAISAL_FAILURE,
  SUBMIT_APPRAISAL,
  SUBMIT_APPRAISAL_SUCCESS,
  SUBMIT_APPRAISAL_FAILURE,
  SET_EMPLOYEE_YEAR,
  SET_APPRAISAL_TAB,
} from 'constants/ActionTypes';

const year = new Date().getFullYear();
export default function Appraisal(state = {
  appraisals: [],
  openAppraisals: [],
  appraisalsById: {},
  appraisalAnswers: {},
  loading: true,
  loadingById: {},
  isSaving: false,
  error: null,
  tab: EMPLOYEE_TAB,
  year,
  yearOptions: range(year - 2, year + 2),
}, action) {
  switch (action.type) {
    case SET_APPRAISAL_TAB:
      return {
        ...state,
        tab: action.tab,
      };
    case SET_EMPLOYEE_YEAR:
      return {
        ...state,
        year: action.year,
      };
    case RESET_APPRAISAL_LOADING:
      return {
        ...state,
        loadingById: {},
      };
    case REQUEST_APPRAISAL:
      return {
        ...state,
        error: null,
        loading: true,
        appraisals: [],
      };
    case REQUEST_APPRAISAL_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        appraisals: action.appraisals.sort((a, b) => compare(a.EmployeeDueDate, b.EmployeeDueDate)),
        openAppraisals: action.openAppraisals,
        yearOptions: [...new Set([...map(action.appraisals, a => new Date(a.FinalAppraisalDate).getFullYear()).sort(), year])],
      };
    case REQUEST_APPRAISAL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        appraisals: [],
      };
    case REQUEST_APPRAISAL_BY_ID:
      return {
        ...state,
        error: null,
        loadingById: {
          ...state.loadingById,
          [action.appraisalId]: true,
        },
      };
    case REQUEST_APPRAISAL_BY_ID_SUCCESS:
      return {
        ...state,
        error: null,
        loadingById: {
          ...state.loadingById,
          [action.appraisal.PMAppraisalID]: false,
        },
        appraisalsById: {
          ...state.appraisalsById,
          [action.appraisal.PMAppraisalID]: action.appraisal,
        },
        expiredById: {
          [action.appraisal.PMAppraisalID]: false,
        },
        /* appraisalAnswers: {
          ...state.appraisalAnswers,
          [action.appraisal.PMAppraisalID]: action.answers,
        }, */
      };
    case SET_FINAL_ANSWERS:
      return {
        ...state,
        appraisalAnswers: {
          ...state.appraisalAnswers,
          [action.appraisalId]: {
            ...state.appraisalAnswers[action.appraisalId],
            finalAnswers: action.answers,
          },
        },
      };
    case SET_MANAGER_ANSWERS:
      return {
        ...state,
        appraisalAnswers: {
          ...state.appraisalAnswers,
          [action.appraisalId]: {
            ...state.appraisalAnswers[action.appraisalId],
            managerAnswers: action.answers,
          },
        },
      };
    case SET_EMPLOYEE_ANSWERS:
      return {
        ...state,
        appraisalAnswers: {
          ...state.appraisalAnswers,
          [action.appraisalId]: {
            ...state.appraisalAnswers[action.appraisalId],
            employeeAnswers: action.answers,
          },
        },
      };
    case REQUEST_APPRAISAL_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        loadingById: {
          ...state.loadingById,
          [action.appraisalId]: false,
        },
        appraisalsById: {},
      };
    case SAVING_APPRAISAL:
      return {
        ...state,
        isSaving: true,
        error: null,
      };
    case SAVING_APPRAISAL_FAILURE:
      return {
        ...state,
        isSaving: false,
        error: action.error,
      };
    case SAVING_APPRAISAL_SUCCESS:
      return {
        ...state,
        isSaving: false,
        error: null,
        expiredById: {
          [action.id]: true,
        },
      };
    case SUBMIT_APPRAISAL:
      return {
        ...state,
        isSubmitting: true,
        error: null,
      };
    case SUBMIT_APPRAISAL_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.error,
      };
    case SUBMIT_APPRAISAL_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        error: null,
        expiredById: {
          [action.id]: true,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Appraisal.js